module.exports = __webpack_public_path__ + "img/xaas-security.9881abc.png";